import { render, staticRenderFns } from "./SapphireVideo.vue?vue&type=template&id=58c6b5ed&lang=html"
import script from "./SapphireVideo.vue?vue&type=script&lang=js"
export * from "./SapphireVideo.vue?vue&type=script&lang=js"
import style0 from "./SapphireVideo.vue?vue&type=style&index=0&id=58c6b5ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports